import React from 'react';

import { StoreOutlineIcon } from 'src/assets/store-outline-icon';
import { Typography } from 'src/typography';
import { CenteredColumn, StepPanel, StepFooter, StepHeader, StepButton, SkipButton } from '../shared-components';

type WaitingStepProps = {
  onNext: (data: { waitingAtDispensary: boolean }) => Promise<void> | void;
  onBack: () => void;
};

export const WaitingStep = ({ onNext, onBack }: WaitingStepProps): JSX.Element | null => {
  const handleSubmit = (data: { waitingAtDispensary: boolean }): void => {
    void onNext({ waitingAtDispensary: data.waitingAtDispensary });
  };

  return (
    <>
      <StepHeader onBack={onBack} />
      <StepPanel>
        <CenteredColumn>
          <StoreOutlineIcon />
          <Typography.Heading tag='h2' size='medium'>
            Are you physically waiting at a dispensary?
          </Typography.Heading>
        </CenteredColumn>
      </StepPanel>

      <StepFooter>
        <StepButton onClick={() => handleSubmit({ waitingAtDispensary: true })} mt='16px'>
          Yes
        </StepButton>
        <SkipButton onClick={() => handleSubmit({ waitingAtDispensary: false })}>Not Yet</SkipButton>
      </StepFooter>
    </>
  );
};
